import * as React from 'react'
import * as Tgcc from '../tgccGlobal'
import Radium, { StyleRoot } from 'radium';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import {ButtonToolbar,DropdownButton,Dropdown} from 'react-bootstrap';


const galaxyFoldBreakpoint = '@media (min-width: 280px) and (max-width: 320px)';


const containerStyle: React.CSSProperties = {
    height:'75px',
    width:'100%',
    textAlign:'center'
};
const navItemStyle: React.CSSProperties = {
    fontFamily:'Roboto !important',
    padding: '20px 10px', // Reduced horizontal padding for more items to fit in a single row
    cursor:'pointer',
    color: 'rgb(24, 17, 71)',
    ':hover':{
        color:'#c2b186'
    }
}
const navigationBarStyle: React.CSSProperties = {
    display: 'flex',
    alignSelf: 'center',
    justifyContent: 'flex-start', // Align items to the start of the nav bar
    border: '1px solid rgba(255,255,255,0.3)',
    alignItems: 'center',
    flexDirection: 'row',
};
const topNavigationContainerStyle: React.CSSProperties = {
    width: '100%',
    height: '106px',
    zIndex: 1000,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: 'white',
    alignItems: 'center', // This will keep items vertically centered
    position: 'fixed',
    padding: '0 20px', // Increased padding for breathing space
    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)', // Added box shadow

  };

const topNavStyle: React.CSSProperties = {
    width:'131px',
    height:'40px',
    backgroundColor:'rgb(24, 17, 71)',
    margin:'13px 10px',
    lineHeight:'38px',
    padding:'5px',
    fontFamily:'Roboto !important',
    cursor:'pointer',
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    color:'white',
    [galaxyFoldBreakpoint]: {
    }
}
const mobileBreakpoint = 768; // pixels, typical tablet breakpoint

// Inside your component's render method or functional component body
const windowWidth = window.innerWidth;
const loggedIn: React.CSSProperties = {
    position: 'absolute',
    color: 'rgb(24, 17, 71)',
    right: '20px', // More padding from the right edge
    top: '80px',
    fontFamily: 'Barlow, sans-serif',
    display: windowWidth < mobileBreakpoint ? 'none' : 'block'
};

const leftSectionStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center', // if you want to vertically center your logo and nav
  };
  

const imgFile = Tgcc.ResolveUrl('~/images/2022Logo.png');

const imgStyles : React.CSSProperties ={
    cursor:'pointer',
    width:'75px',
    fill: 'white',
    backgroundColor: 'white',
    borderRadius: '100px',
    height:'75px',
};
const txt: React.CSSProperties = {
    fontFamily:"BarlowMedium",
    marginLeft:'20px',
}
const logoStyle: React.CSSProperties = {
    marginRight: '20px', // Adjusted space between logo and navBar
    display: 'flex',
    alignItems: 'center',
};
const rightSectionStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'flex-end', // Aligns content to the right side of this container
    alignItems: 'center', // Align items vertically in this container
};

const GCText: React.CSSProperties = {
    fontFamily:"BarlowMedium",
}
const emailStyle: React.CSSProperties = {
    fontFamily:'BarlowMedium',
    color: 'rgb(24, 17, 71)', // Ensure text is white for visibility
    marginRight: '20px', // More padding from the right edge
}
const mobileNav: React.CSSProperties = {
    display:'flex',
    backgroundColor: 'rgb(24, 17, 71)',
    paddingBottom: '5px',
    [galaxyFoldBreakpoint]: {
        margin: '0 0 0 0',
    }

}
const hamburger: React.CSSProperties = {
    backgroundImage:'url('+ Tgcc.ResolveUrl("~/images/hamburger_2.png"),
    height:'50px',
    width:'50px',
    backgroundPosition:'center',
    backgroundSize:'cover',
}

const hamburgerStyle: React.CSSProperties = {
    backgroundImage: 'url(' + Tgcc.ResolveUrl("~/images/hamburger_2.png") + ')',
    height: '50px',
    width: '50px',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    border: 'none',
    backgroundColor: 'transparent',
    padding: 0
};

const dropdownItemStyle: React.CSSProperties = {
    display: 'block',
    padding: '10px 15px',
    fontFamily: 'Roboto',
    fontSize: '16px',
    borderBottom: '1px solid #eee',
    textTransform: 'uppercase',
    color: '#333'
};


const topLoginStyle = Object.assign({}, topNavStyle);

class _TBankerHeader extends React.Component < Tgcc.BaseProps, any > {

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const returnUrl = urlParams.get('returnUrl');
        this.setState({ returnUrl });
    }

    openDashboard = () => {browserHistory.push(Tgcc.Routes.DashBoard)};
    openCSR = () => {browserHistory.push(Tgcc.Routes.CSR)};
    openDesign = () => {browserHistory.push(Tgcc.Routes.MajorAccountsDesignListView)};
    openHome = () => {browserHistory.push(Tgcc.Routes.Home)};
    openContact = () => {browserHistory.push(Tgcc.Routes.Contact)}

   
    openProducts = () => {browserHistory.push(Tgcc.Routes.ProductCategoryListView)};
    openRegister = () =>{browserHistory.push(Tgcc.Routes.Register)}

    loginUser = () => {
        // Use window.location.href to get the full URL, not just pathname
        const currentUrl = window.location.href; 
        const returnUrlParam = encodeURIComponent(currentUrl); // Ensure the URL is encoded
        const loginUrl = `${Tgcc.Routes.Login}?returnUrl=${returnUrlParam}`;
        browserHistory.push(loginUrl);
    }
    
    logoutUser = () => {
        Tgcc.LogoutUser(this.props.dispatch, this.props.state.LoginData);
        this.props.dispatch({type:Tgcc.StateAction.ForwardLocation, payload:this.props.state.ActiveProof});
    }

    getLoginLink(){
        if(this.props.state.LoginData){
            return <div style={topLoginStyle} className="logStyle" key={1} onClick={this.logoutUser}>Logout</div>
        }
        return <div  style={topLoginStyle} className="logStyle" key={2} onClick={this.loginUser}>Login</div>
    }
    getDashboardLink(){
        if(!this.props.state.LoginData){
            return <div style={topNavStyle} key={3} className="acctStyle" onClick={this.openRegister}>Create Account</div>
        }
        return <div style={topNavStyle} key={4} className="acctStyle" onClick={this.openDashboard}>Dashboard</div>
    }
    getUserName(){
        if(this.props.state.LoginData && this.props.state.LoginData.impersonate)
            return <div style={loggedIn}>Impersonating: {this.props.state.LoginData.impersonate}</div>
            
        if(this.props.state.UserInfo && this.props.state.UserInfo.email)
            return <div style={loggedIn} className='maloggedStyle'>Logged in as: <span style={emailStyle}>{this.props.state.UserInfo.email}</span></div>
    }
    openProofEdit = () => {
        if(this.props.state.LoginData && this.props.state.UserInfo){
            browserHistory.push(Tgcc.Routes.ProofEdit)
        }
        else {
            browserHistory.push(Tgcc.Routes.Register)
        }    
    };
    getMobile() {
        const logLink = this.getLoginLink();
        const dbLink = this.getDashboardLink();
    
        if (window.innerWidth <= 440) {
            return (
                <div style={mobileNav}>
                    <Dropdown>
                        <Dropdown.Toggle
                            id="mobile-dropdown"
                            style={hamburgerStyle}
                            variant="light"
                        />
                        <Dropdown.Menu>
                            <Dropdown.Item style={dropdownItemStyle} eventKey="101" onClick={this.openHome}>HOME</Dropdown.Item>
                            <Dropdown.Item style={dropdownItemStyle} eventKey="102" onClick={this.openDesign}>DESIGNS</Dropdown.Item>
                            <Dropdown.Item style={dropdownItemStyle} eventKey="103" onClick={this.openProofEdit}>GET STARTED</Dropdown.Item>
                            <Dropdown.Item style={dropdownItemStyle} eventKey="104" onClick={this.openProducts}>PRODUCTS</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <div style={mobileNav} className="campuMobileLink">
                        {logLink}
                        {dbLink}
                    </div>
                    {this.getUserName()}
                </div>
            );
        }
    
        // desktop view (unchanged)
        return (
            <div style={topNavigationContainerStyle} className="maTopNav">
                <div style={leftSectionStyle} className="leftSection">
                    <div onClick={this.openHome} style={logoStyle} className="campusNvLogo">
                        <img src={imgFile} style={imgStyles} />
                    </div>
                    <div style={navigationBarStyle} className="newCampusNv">
                        <div key={99} style={navItemStyle} onClick={this.openHome}>HOME</div>
                        <div key={96} style={navItemStyle} onClick={this.openDesign}>DESIGNS</div>
                        <div key={97} style={navItemStyle} onClick={this.openProofEdit}>GET STARTED</div>
                        <div key={95} style={navItemStyle} onClick={this.openProducts}>PRODUCTS</div>
                    </div>
                </div>
                <div style={rightSectionStyle} className="logNav">
                    {logLink}
                    {dbLink}
                </div>
                {this.getUserName()}
            </div>
        );
    }
    
    render() {
        var navbar = this.getMobile();
        return (
            <div style={containerStyle} className="majorHdrDiv">
                {navbar}
              
            </div>
        )

    }
    
}
const mapStateToProps = (state: Tgcc.GlobalState) => {
    return { 
        state: state
    };
};

export var TBankerHeader = connect(mapStateToProps)(Radium(_TBankerHeader));